import {
  U1_LESSONS,
  U2_LESSONS,
  U3_LESSONS,
  U4_LESSONS,
  U5_LESSONS,
} from './lessons-a1.js';
import {
  U10_LESSONS,
  U6_LESSONS,
  U7_LESSONS,
  U8_LESSONS,
  U9_LESSONS,
} from './lessons-a2.js';
import {
  U11_LESSONS,
  U12_LESSONS,
  U13_LESSONS,
  U14_LESSONS,
  U15_LESSONS,
} from './lessons-b1.js';
import {
  U16_LESSONS,
  U17_LESSONS,
  U18_LESSONS,
  U19_LESSONS,
  U20_LESSONS,
} from './lessons-b2.js';
import type { Section } from './types.js';

// ============================================================================
// Universos temáticos — o currículo é organizado por contextos do mundo real,
// não mais por níveis CEFR. Cada universo começa fácil (A1) e cresce, e pop
// culture entra como tema visual dentro de cada universo.
// ============================================================================

export const SECTIONS: Section[] = [
  {
    id: 's-greet',
    number: 1,
    title: 'Cumprimentos & Identidade',
    subtitle: 'Se apresentar e começar a conversa',
    cefr: 'A1',
    units: [
      { id: 'u1', number: 1, title: 'Diga olá', subtitle: 'Cumprimentos do dia', theme: 'Harry Potter', cefr: 'A1', color: 'owl', lessons: U1_LESSONS },
      { id: 'u4', number: 2, title: 'Comida e café', subtitle: 'Pedir sem travar', theme: 'Harry Potter / Ghibli', cefr: 'A1', color: 'macaw', lessons: U4_LESSONS },
    ],
  },
  {
    id: 's-travel',
    number: 2,
    title: 'Viagens & Aeroportos',
    subtitle: 'Do check-in ao check-out',
    cefr: 'A2',
    units: [
      { id: 'u8', number: 1, title: 'Aeroporto, cidade, hotel', subtitle: 'Sobreviver fora do país', theme: 'Indiana Jones / Peaky Blinders', cefr: 'A2', color: 'peacock', lessons: U8_LESSONS },
      { id: 'u2', number: 2, title: 'Números, cores, dias', subtitle: 'Horários e datas', theme: 'Demon Slayer / Friends', cefr: 'A1', color: 'beetle', lessons: U2_LESSONS },
    ],
  },
  {
    id: 's-home',
    number: 3,
    title: 'Casa, Família & Rotina',
    subtitle: 'O mundo do cotidiano',
    cefr: 'A1',
    units: [
      { id: 'u3', number: 1, title: 'Família e rotina', subtitle: 'Quem é quem, o que faz', theme: 'The Incredibles / The Office', cefr: 'A1', color: 'peacock', lessons: U3_LESSONS },
      { id: 'u5', number: 2, title: 'Minha casa', subtitle: 'Ambientes e lugares', theme: 'Toy Story', cefr: 'A1', color: 'fox', lessons: U5_LESSONS },
    ],
  },
  {
    id: 's-food',
    number: 4,
    title: 'Restaurantes & Compras',
    subtitle: 'Pedir, pagar, reclamar',
    cefr: 'A2',
    units: [
      { id: 'u9', number: 1, title: 'No caixa e na loja', subtitle: 'How much / how many', theme: 'Breaking Bad / Devil Wears Prada', cefr: 'A2', color: 'cardinal', lessons: U9_LESSONS },
      { id: 'u7', number: 2, title: 'Conversa informal', subtitle: 'Hobbies e frequência', theme: 'Naruto / Sherlock / Friends', cefr: 'A2', color: 'beetle', lessons: U7_LESSONS },
    ],
  },
  {
    id: 's-school-work',
    number: 5,
    title: 'Escola & Trabalho',
    subtitle: 'Gramática de quem vive no mundo',
    cefr: 'B1',
    units: [
      { id: 'u6', number: 1, title: 'Passado simples', subtitle: 'Contar o que aconteceu', theme: 'LOTR / Star Wars / Sherlock', cefr: 'A2', color: 'owl', lessons: U6_LESSONS },
      { id: 'u10', number: 2, title: 'Passado contínuo & comparações', subtitle: 'Estava acontecendo + maior/melhor', theme: 'Stranger Things / Avengers / GoT', cefr: 'A2', color: 'macaw', lessons: U10_LESSONS },
      { id: 'u12', number: 3, title: 'Condicionais & carreira', subtitle: 'If you do X, Y happens', theme: 'The Matrix / Peaky Blinders', cefr: 'B1', color: 'butterfly', lessons: U12_LESSONS },
    ],
  },
  {
    id: 's-media',
    number: 6,
    title: 'Tecnologia & Mídia',
    subtitle: 'Falar sobre o que se vê e ouve',
    cefr: 'B1',
    units: [
      { id: 'u15', number: 1, title: 'Discurso indireto', subtitle: 'Reportando o que foi dito', theme: 'Black Mirror', cefr: 'B1', color: 'macaw', lessons: U15_LESSONS },
      { id: 'u13', number: 2, title: 'Present perfect', subtitle: 'Experiências de vida', theme: 'Dark', cefr: 'B1', color: 'kiwi', lessons: U13_LESSONS },
      { id: 'u14', number: 3, title: 'Modais', subtitle: 'Pode / deve / precisa', theme: 'Spider-Man', cefr: 'B1', color: 'cardinal', lessons: U14_LESSONS },
    ],
  },
  {
    id: 's-pop-advanced',
    number: 7,
    title: 'Cultura Pop Avançada',
    subtitle: 'Fluência e nuance de filme',
    cefr: 'B2',
    units: [
      { id: 'u11', number: 1, title: 'Futuro — will / going to', subtitle: 'Promessas e planos', theme: 'Avengers / Attack on Titan', cefr: 'B1', color: 'starfish', lessons: U11_LESSONS },
      { id: 'u16', number: 2, title: 'Voz passiva + condicionais complexos', subtitle: 'Estrutura avançada', theme: 'Dune / Inception', cefr: 'B2', color: 'owl', lessons: U16_LESSONS },
      { id: 'u17', number: 3, title: 'Phrasal verbs', subtitle: 'Inglês natural do dia a dia', theme: 'Death Note', cefr: 'B2', color: 'beetle', lessons: U17_LESSONS },
      { id: 'u18', number: 4, title: 'Ideias abstratas', subtitle: 'Tempo, espaço, amor', theme: 'Interstellar', cefr: 'B2', color: 'peacock', lessons: U18_LESSONS },
      { id: 'u19', number: 5, title: 'Idioms', subtitle: 'Expressões idiomáticas', theme: 'Rick and Morty', cefr: 'B2', color: 'fox', lessons: U19_LESSONS },
      { id: 'u20', number: 6, title: 'Nuance & hedging', subtitle: 'Suavizar afirmações', theme: 'True Detective', cefr: 'C1', color: 'butterfly', lessons: U20_LESSONS },
    ],
  },
];

export type {
  CharacterKey,
  Exercise,
  Lesson,
  Section,
  Unit,
  UnitColor,
  VoicePreset,
  IllustrationKey,
} from './types.js';
export { CHARACTER_META, LEAGUE_TIERS, VOICE_IDS } from './types.js';
